import { Resource as i, API as s } from "@coveo/platform-client";
const t = class t extends i {
  getFields(e) {
    return this.api.post(`${t.baseUrl}/${e}/fields`);
  }
  /**
   * Returns a paginated list of catalogs for the specified project.
   *
   * @param {string} projectId ID of the project for which to retrieve catalogs.
   * @param {CatalogsListOptions} options Options to modify the request, such as pagination and filtering.
   * @returns {Promise<PageModel<CatalogModel>>} Paginated list of catalogs for the specified project.
   */
  listCatalogsByProjectId(e, a = {}) {
    return this.api.get(
      this.buildPath(`${t.baseCatalogUrl}/project`, {
        ...a,
        projectId: e
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${s.orgPlaceholder}/commerce/v2/catalog`, t.baseCatalogUrl = `/rest/organizations/${s.orgPlaceholder}/catalogs`;
let r = t;
export {
  r as Catalog
};
//# sourceMappingURL=Catalog.js.map
